import safeNumberConversion from "utils/safeNumberConversion";
import { statusOptions } from "../../../../../DataGridTable/FieldTypes/StatusCell";

export default function normalizeImportValue({ key, value, type }) {
  if (!value || value === '' || (typeof value === 'string' && value.toLowerCase() === 'n/a')) {
    return null;
  }
  
  if (key === 'status') {
    const normalizedStatus = String(value).trim().toLowerCase();
    const matchedStatus = statusOptions.find(opt => 
      opt.value.toLowerCase() === normalizedStatus ||
      opt.label.toLowerCase() === normalizedStatus ||
      opt.aliases?.some(alias => alias.toLowerCase() === normalizedStatus)
    );
    return matchedStatus?.value ?? null;
  }
  
  if (type === 'percent' || type === 'number') {
    return safeNumberConversion(value);
  }
  
  return value;
}

